import supplier from "@/apis/supplier";
import SDoc from "@/components/SDoc";
import CustomTabPane, { TabProps } from "@/components/TabPane";
import { OrderV2 } from "@/types/inventoryV2";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import OrderView from "./components/OrderList";


export type CustomerTabType = 'doc'

const OrderV2Home: FC = () => {
  const { t } = useTranslation();

  const keyObj: (order: OrderV2) => { [key in CustomerTabType]: TabProps } = (order) => ({
    doc: {
      key: 'doc',
      label: (order?.number) + ' ' + t('purchase.documents'),
      children: <SDoc docId={order.docId} />
    },
  })

  return <CustomTabPane<OrderV2> defaultKey={'list'} defaultTabs={[
    {
      key: 'list',
      label: t("order.inOutNo"),
      children: <OrderView />,
      closable: false,
    },
  ]} onOpens={(info) => keyObj(info)} />
}

export default OrderV2Home;